import axios from "axios";
import environment from '../environment'
import currentLanguage from '../services/language';

let axiosInstance =
    axios.create({
        baseURL: environment.baseUrl,
        headers: {
            'X-Api-Key': environment.apiKey,
            'Language': currentLanguage(),
        }
    });

export const request = axiosInstance;